import { Marker } from 'react-map-gl/mapbox'
import 'mapbox-gl/dist/mapbox-gl.css'
import '../styles.css'
import { showLivePulse } from '../util'

type CurrentPositionMarkerProps = {
  lat: number | null | undefined
  lon: number | null | undefined
  lastHeartbeat: string | null | undefined
  complete: boolean
}

export function CurrentPositionMarker({ lat, lon, lastHeartbeat, complete }: CurrentPositionMarkerProps) {
  if (!lat || !lon) {
    return null
  }

  const showPulse = showLivePulse(lastHeartbeat, complete)

  return (
    <Marker longitude={lon} latitude={lat} anchor='bottom' offset={[6, 6]}>
      <div className='current-position-container'>
        <div className={showPulse ? 'pulse-ring small current-position-pulse' : ''} />
        <div className='current-position-marker' />
      </div>
    </Marker>
  )
}
